type Handler<E extends Event> = (e: E) => void;
type CanHaveEventListener<
  K extends string,
  E extends Event,
  L extends Handler<E>,
> = {
  addEventListener(
    type: K,
    listener: L,
    options?: boolean | AddEventListenerOptions,
  ): void;
  removeEventListener(
    type: K,
    listener: L,
    options?: boolean | EventListenerOptions,
  ): void;
};
type RemoveEventListener = () => void;

//addEventListener() is a helper that returns a fn to later remove the event listener
export const addEventListener = <
  K extends string,
  E extends Event,
  L extends Handler<E>,
>(
  o: CanHaveEventListener<K, E, L>,
  eventName: K,
  listener: L,
  options?: boolean | AddEventListenerOptions,
): RemoveEventListener => {
  o.addEventListener(
    eventName,
    listener,
    ...(options != null ? [options] : []),
  );
  return () => o.removeEventListener(eventName, listener);
};

export const addEventListenerAndCollectRemovers = <
  K extends string,
  E extends Event,
  L extends Handler<E>,
>(
  collection: RemoveEventListener[],
  o: CanHaveEventListener<K, E, L>,
  eventName: K,
  listener: L,
  options?: boolean | AddEventListenerOptions,
): void => {
  collection.push(addEventListener(o, eventName, listener, options));
};

export const runRemoveEventListeners = (
  collection: RemoveEventListener[],
): void => {
  for (const c of collection) {
    c();
  }
  collection.length = 0;
};
